import { AsyncGridColumns, ColumnLink } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.name',
    field: 'name',
    sortable: false,
    flex: 1,
    minWidth: 240,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'column.inn',
    field: 'inn',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.kpp',
    field: 'kpp',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.ogrn',
    field: 'ogrn',
    sortable: false,
    flex: 1,
  },
]
